(function(){
  'use strict';

  angular
      .module('checker.data')
      .factory('InteractionsCalculator', InteractionsCalculator);

  InteractionsCalculator.$inject = ['CheckerData'];

  function InteractionsCalculator(CheckerData) {

    var calculatedInteractions = [],
        availableInteractions = [],
        selectedDrugs = [],
        selectedComeds = [];

    return {
      checkForInteractions: checkForInteractions
    };

    // ////////////////////////////////////////////////////////

    // // calculate interactions for selected drugs and comeds
    function checkForInteractions(drugs, comeds, checkPrimaryInts, drugClass, siteType, lang){
      if (drugClass > 0) {
        // View All Checker
        calculatedInteractions = [];
        selectedDrugs = drugs;
        return CheckerData.fetchAvailableInteractionsByClass(drugs, drugClass, siteType, lang).then(function(data) {
          availableInteractions = data;
          checkViewAllInteractions(drugs);
          return calculatedInteractions;
        })
      } else {
        if (checkSelected) {
          calculatedInteractions = [];
          selectedDrugs = drugs;
          selectedComeds = comeds;
          return CheckerData.fetchAvailableInteractions(drugs, comeds, siteType, lang).then(function(data) {
            availableInteractions = data;
            checkStandardInteractions(drugs, comeds);

            if (checkPrimaryInts) {
              checkCrossInteractions(drugs);
            }
            return calculatedInteractions;
          })
        }
      }

      return calculatedInteractions;
    }

    function checkViewAllInteractions (drugs) {
      drugs.forEach(function(drug){
        
        var interactions = _.filter(availableInteractions, function(interaction){
          return (interaction.primary_drug_id === drug.id);
        });
        if (!!interactions) {
          calculatedInteractions.push(interactions);
        }
      });
    }

    function checkStandardInteractions (drugs, comeds) {
      drugs.forEach(function(drug){
        var pairsToCheck = [];

        comeds.forEach(function(comed){
          var drugPair = {};
          drugPair.hivDrugId = drug.id;
          drugPair.comedId = comed.id;
          pairsToCheck.push(drugPair);
        });

        checkDrugPairs(pairsToCheck);
      });
    }

    function checkCrossInteractions (drugs) {
      drugs.forEach(function(drug, i){
        var pairsToCheck = [];

        drugs.forEach(function(crossDrug, j){
          var drugPair = {};
          if (j > i){
            drugPair.hivDrugId = drug.id;
            drugPair.comedId = crossDrug.id;
            pairsToCheck.push(drugPair);
          }
        });

        checkDrugPairs(pairsToCheck);
      });
    }

    // // check for interaction hits for a passed in array of drug/comed IDs
    function checkDrugPairs (pairs) {
      pairs.forEach(function(combo){
        var interactions = _.find(availableInteractions, function(interaction){
          return (interaction.primary_drug_id === combo.hivDrugId && interaction.co_drug_id === combo.comedId);
        });
        if (typeof interactions != 'undefined') {
          interactions.primary_drug_name = findDrug(interactions.primary_drug_id);
          interactions.co_drug_name = findCoMed(interactions.co_drug_id);
          interactions.co_drug_class = findCoMedClass(interactions.co_drug_id);
          interactions.primary_drug_class = findPrimaryDrugClass(interactions.primary_drug_id);
          interactions.infoVisible = false;
          calculatedInteractions.push(interactions);
        }
      });
    }

    // // check that at least one drug and one comed have been selected
    function checkSelected(drugs, comeds) {
      return !!(drugs.length > 1 || (drugs.length > 0 && comeds.length > 0));
    }

    // // Match drug ids to drug name
    function findDrug (drugId){
      var theDrug = _.find(selectedDrugs, function(drug){
        return (drug.id == drugId);
      });
      return (theDrug.name);
    }

    function findPrimaryDrugClass(drugId){
      var theDrug = _.find(selectedDrugs, function(drug){
        return (drug.id == drugId);
      });
      return (theDrug.drug_class_name);
    }

    // // Match co-med ids to drug name
    function findCoMed (drugId){
      var theCoMed = _.find(selectedComeds, function(coMed){
        return (coMed.id == drugId);
      });
      if (typeof theCoMed != 'undefined') {
        return (theCoMed.name);
      } else {
        return (findDrug(drugId));
      }
    }

    function findCoMedClass(drugId){
      var theCoMed = _.find(selectedComeds, function(coMed){
        return (coMed.id == drugId);
      });
      if (typeof theCoMed != 'undefined') {
        return (theCoMed.drug_class_name)
      }
    }
  }

})();
